import { Link } from 'react-router-dom';

interface LogoProps {
  size?: 'sm' | 'md' | 'lg';
  linkTo?: string;
}

const sizes = {
  sm: { box: 'h-8 w-8 rounded-[8px] text-base', text: 'text-base' },
  md: { box: 'h-9 w-9 rounded-[10px] text-lg', text: 'text-lg' },
  lg: { box: 'h-11 w-11 rounded-[12px] text-xl', text: 'text-xl' },
};

export default function Logo({ size = 'md', linkTo }: LogoProps) {
  const s = sizes[size];

  const content = (
    <div className="flex items-center gap-2.5">
      <div
        className={`flex items-center justify-center ${s.box}`}
        style={{
          background:
            'linear-gradient(135deg, rgb(99,102,241), rgb(167,139,250))',
        }}
      >
        🎭
      </div>
      <span className={`${s.text} font-bold text-foreground`}>
        the
        <span style={{ color: 'rgb(129,140,248)' }}>RolePlay</span>
        Lab
      </span>
    </div>
  );

  if (linkTo) {
    return (
      <Link to={linkTo} className="no-underline">
        {content}
      </Link>
    );
  }

  return content;
}
